import { css } from '@emotion/css';

export const orderedListStyles = css`
  li {
    padding-inline-start: 1.6rem;
  }
  li::marker {
    font-size: 1.8rem;
  }
`;
